var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowMinimize component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowMinimize extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.22043 1.45145C1.51043 1.16145 1.99043 1.16145 2.28043 1.45145L7.24043 6.41145V2.76145C7.24043 2.35145 7.58043 2.01145 7.99043 2.01145C8.40043 2.01145 8.74043 2.35145 8.74043 2.76145V8.21145C8.74043 8.41145 8.67043 8.60145 8.52043 8.75145C8.37043 8.90145 8.17043 8.97145 7.98043 8.97145H2.53043C2.12043 8.97145 1.78043 8.63145 1.78043 8.22145C1.78043 7.81145 2.12043 7.47145 2.53043 7.47145H6.18043L1.22043 2.51145C0.93043 2.22145 0.93043 1.74145 1.22043 1.45145ZM8.74043 16.0414C8.74043 15.8414 8.67043 15.6514 8.52043 15.5014C8.44043 15.4214 8.34043 15.3614 8.23043 15.3214C8.15043 15.2914 8.07043 15.2814 7.99043 15.2814H2.53043C2.12043 15.2814 1.78043 15.6214 1.78043 16.0314C1.78043 16.4414 2.12043 16.7814 2.53043 16.7814H6.18043L1.22043 21.7414C0.93043 22.0314 0.93043 22.5114 1.22043 22.8014C1.51043 23.0914 1.99043 23.0914 2.28043 22.8014L7.24043 17.8414V21.4914C7.24043 21.9014 7.58043 22.2414 7.99043 22.2414C8.40043 22.2414 8.74043 21.9014 8.74043 21.4914V16.0414V16.0414ZM17.6004 16.7814H21.2504C21.6604 16.7814 22.0004 16.4414 22.0004 16.0314C22.0004 15.6214 21.6604 15.2814 21.2504 15.2814H15.7904C15.6904 15.2814 15.5904 15.3014 15.5004 15.3414C15.4104 15.3814 15.3304 15.4314 15.2604 15.5014C15.1904 15.5814 15.1404 15.6614 15.1004 15.7514C15.0604 15.8414 15.0404 15.9414 15.0404 16.0414V21.5014C15.0404 21.9114 15.3804 22.2514 15.7904 22.2514C16.2004 22.2514 16.5404 21.9114 16.5404 21.5014V17.8514L21.5004 22.8114C21.7904 23.1014 22.2704 23.1014 22.5604 22.8114C22.8504 22.5214 22.8504 22.0414 22.5604 21.7514L17.6004 16.7914V16.7814ZM22.5704 1.45145C22.8604 1.74145 22.8604 2.22145 22.5704 2.51145L17.6104 7.47145H21.2604C21.6704 7.47145 22.0104 7.81145 22.0104 8.22145C22.0104 8.63145 21.6704 8.97145 21.2604 8.97145H15.8104C15.6104 8.97145 15.4204 8.90145 15.2704 8.75145C15.1904 8.67145 15.1304 8.57145 15.0904 8.46145C15.0604 8.38145 15.0504 8.30145 15.0504 8.22145V2.76145C15.0504 2.35145 15.3904 2.01145 15.8004 2.01145C16.2104 2.01145 16.5504 2.35145 16.5504 2.76145V6.41145L21.5104 1.45145C21.8004 1.16145 22.2804 1.16145 22.5704 1.45145Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowMinimize.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowMinimize.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowMinimize.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-minimize') === undefined) {
    customElements.define('cat-icon-arrow-minimize', BlocksIconArrowMinimize);
}
